export default __webpack_public_path__ + "static/media/email.917465e9.svg";